import React, { FC } from "react";
import styled from "styled-components";

import Heading, { HeadingVariant } from "src/components/Heading";
import Form from "src/components/Form";
import { mediaQuery } from "src/themes/breakpoints";
import { colors } from "src/themes/colors";

const Wrapper = styled.div<ContactsBlockProps>`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${(props) => (props.$nopadding ? "0" : "30px 20px 50px")};

  ${mediaQuery("md")} {
    padding: ${(props) => (props.$nopadding ? "0" : "100px 20px 60px")};
  }
`;

const Contact = styled.a`
  color: ${colors.blue};
  margin-top: 4px;
  position: relative;
  text-decoration: none;

  &:after {
    background: none repeat scroll 0 0 transparent;
    background-color: ${colors.blue};
    bottom: 0;
    content: "";
    display: block;
    height: 1px;
    left: 0;
    position: absolute;
    transition: width 0.3s ease 0s, left 0.3s ease 0s;
    width: 0;
  }

  &:hover:after {
    width: 100%;
  }

  ${mediaQuery("md")} {
    font-size: 18px;
  }
`;

const Title = styled(Heading)`
  margin-bottom: 20px;
  text-align: center;
`;

interface ContactsBlockProps {
  title: string;
  contacts: {
    phone: string;
    email: string;
    address: string;
  };
  isContactsPage?: boolean;
}

const ContactsBlock: FC<ContactsBlockProps> = ({
  title,
  contacts,
  isContactsPage,
}) => {
  const { phone, email, address } = contacts;

  return (
    <Wrapper $nopadding={isContactsPage}>
      <Title
        variant={isContactsPage ? HeadingVariant.ALFA : HeadingVariant.BRAVO}
      >
        {title}
      </Title>
      <Contact href={`tel:${phone}`}>{phone}</Contact>
      <Contact href={`mailto:${email}`}>{email}</Contact>
      <Contact href="https://eimantas-consulting.de/" target="_blank">
        {address}
      </Contact>
    </Wrapper>
  );
};

export default ContactsBlock;
